import styled from "styled-components";


export const Container = styled.section`
  margin-top: 15rem;
  
  h2{
    text-align: center;
    margin-bottom: 6rem;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -1.5rem;
      left: 50%;
      transform: translateX(-50%);
      width: 8rem;
      height: 0.4rem;
      background: var(--gradient-accent);
      border-radius: 2rem;
    }
  }

  .category-group {
    & + .category-group {
      margin-top: 6rem;
    }
  }

  .category-heading {
    display: flex;
    align-items: baseline;
    gap: 1.5rem;
    margin: 0 2rem 2rem;
    padding-bottom: 1.2rem;
    border-bottom: 1px solid rgba(99, 102, 241, 0.18);

    h3 {
      font-size: clamp(1.8rem, 2.5vw, 2.4rem);
      font-weight: 700;
      letter-spacing: 0.02em;
      background: var(--gradient-primary);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    span {
      color: var(--text-light);
      font-size: 1.4rem;
      font-weight: 500;
    }
  }

  :root.light & .category-heading {
    border-bottom-color: rgba(99, 102, 241, 0.25);
    span { color: #475569; }
  }

  .projects{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    grid-auto-rows: minmax(300px, auto);
    gap: 2.5rem;
    padding: 2rem;
    overflow: hidden;

    .project{
      padding: 2.5rem;
      background: linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.9) 100%);
      border: 1px solid rgba(99, 102, 241, 0.2);
      border-radius: 2rem;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      flex-direction: column;
      height: 100%;
      color: #FFF;
      position: relative;
      overflow: hidden;
      backdrop-filter: blur(10px);
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: var(--gradient-primary);
        opacity: 0;
        transition: opacity 0.4s ease;
      }
      
      &:hover{
        transform: translateY(-8px) scale(1.02);
        border-color: var(--primary);
        box-shadow: 0 20px 40px rgba(99, 102, 241, 0.3);
        
        &::before {
          opacity: 1;
        }
      }
      
      /* Featured projects (first 3) */
      &:nth-child(1) {
        grid-column: span 1;
        grid-row: span 1;
        border-color: rgba(139, 92, 246, 0.3);
        
        &::before {
          background: var(--gradient-accent);
        }
      }
      
      &:nth-child(2) {
        grid-column: span 1;
        grid-row: span 1;
        border-color: rgba(6, 182, 212, 0.3);
      }
      
      &:nth-child(3) {
        grid-column: span 1;
        grid-row: span 1;
        border-color: rgba(16, 185, 129, 0.3);
      }

      header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2rem;
        
        svg {
          filter: drop-shadow(0 2px 8px rgba(99, 102, 241, 0.3));
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          
          &:hover {
            filter: drop-shadow(0 4px 16px rgba(99, 102, 241, 0.6));
            transform: translateY(-3px) scale(1.05);
          }
        }
        
        .project-links{
          display: flex;
          align-items: center;
          gap: 1.5rem;
          
          a {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 4rem;
            height: 4rem;
            border-radius: 1rem;
            background: rgba(99, 102, 241, 0.1);
            border: 1px solid rgba(99, 102, 241, 0.2);
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            
            &::before {
              content: '';
              position: absolute;
              inset: -2px;
              border-radius: 1rem;
              padding: 2px;
              background: var(--gradient-primary);
              -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
              -webkit-mask-composite: xor;
              mask-composite: exclude;
              opacity: 0;
              transition: opacity 0.4s ease;
            }
            
            &:hover {
              transform: translateY(-5px) rotate(5deg) scale(1.1);
              background: rgba(99, 102, 241, 0.2);
              border-color: var(--primary);
              box-shadow: 0 8px 24px rgba(99, 102, 241, 0.4);
              
              &::before {
                opacity: 1;
              }
            }
            
            &:active {
              transform: translateY(-2px) scale(1.05);
            }
          }
          
          img {
            width: 2rem;
            height: 2rem;
            filter: brightness(1.1) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
            transition: all 0.3s ease;
          }
          
          a:hover img {
            filter: brightness(1.4) drop-shadow(0 4px 8px rgba(99, 102, 241, 0.5));
          }
        }
      }
      
      h3{
        margin-bottom: 1.5rem;
        font-size: clamp(1.8rem, 2.5vw, 2.2rem);
        font-weight: 700;
        color: #ffffff;
        line-height: 1.3;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease;
      }
      
      &:hover h3 {
        color: var(--primary);
        text-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
      }

      p{
        letter-spacing: 0.05rem;
        margin-bottom: 2rem;
        line-height: 1.7;
        color: var(--text-light);
        font-size: 1.5rem;
        
        a{
          color: var(--accent);
          border-bottom: 1px solid var(--accent);
          transition: all 0.25s;
          &:hover{
            color: var(--success);
            border-color: var(--success);
          }
        }
      }

      footer{
        margin-top: auto;
        padding-top: 2rem;
        border-top: 1px solid rgba(99, 102, 241, 0.1);
        
        .tech-list{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
          font-size: 1.3rem;
          
          li {
            padding: 0.5rem 1.2rem;
            background: rgba(99, 102, 241, 0.15);
            border: 1px solid rgba(99, 102, 241, 0.3);
            border-radius: 0.8rem;
            color: var(--primary);
            font-weight: 500;
            transition: all 0.3s ease;
            
            &:hover {
              background: rgba(99, 102, 241, 0.25);
              transform: translateY(-2px);
            }
          }
        }
      }

    }
  }

  @media (max-width: 1200px){
    .projects{
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 2rem;
    }
  }

  @media (max-width: 960px){
    .projects{
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      padding: 1rem;
      
      .project {
        padding: 2rem;
        
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
          grid-column: span 1;
        }
      }
    }
  }

  @media (max-width: 740px){
    margin-top: 10rem;
    
    h2 {
      margin-bottom: 4rem;
    }
    
    .projects{
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }
  }
`